/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header id="masthead" className="header ttm-header-style-02">
      {/* -- top bar ------------------------------------------------------ */}
      <div className="top_bar ttm-bgcolor-darkgrey ttm-textcolor-white clearfix">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex flex-row align-items-center justify-content-center">
                <div className="top_bar_contact_item">
                  <div className="top_bar_icon">
                    <i className="fa fa-map-marker" />
                  </div>
                  Location: Sector 50, Noida, Uttar Pradesh 201303
                </div>

                <div className="top_bar_contact_item mr-auto">
                  <div className="top_bar_icon">
                    <i className="fa fa-envelope-o" />
                  </div>
                  <a href="mailto:info@metamindinc.com">info@metamindinc.com</a>
                </div>

                <div className="d-flex align-items-center">
                  <div className="top_bar_social ttm-bgcolor-skincolor">
                    <ul className="social-icons">
                      <li className="facebook-icon">
                        <a href="https://www.facebook.com/preyantechnosys19" target="_blank" rel="noreferrer">
                          <i className="ti ti-facebook" />
                        </a>
                      </li>
                      <li className="linkedin-icon">
                        <a href="https://www.linkedin.com/in/preyan-technosys-pvt-ltd/" target="_blank" rel="noreferrer">
                          <i className="ti ti-linkedin" />
                        </a>
                      </li>
                      <li className="twitter-icon">
                        <a href="https://twitter.com/PreyanTechnosys" target="_blank" rel="noreferrer">
                          <i className="ti ti-twitter-alt" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>{/* flex */}
            </div>
          </div>
        </div>
      </div>

      {/* -- main nav ----------------------------------------------------- */}
      <div id="site-header-menu" className="site-header-menu ttm-bgcolor-white">
        <div className="site-header-menu-inner ttm-stickable-header">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="site-navigation d-flex flex-row">
                  {/* brand */}
                  <div className="site-branding mr-auto">
                    <Link className="home-link" to="/">
                      {/* Use Public URL to load logo from public/assets/images */}
                      <img
                        id="logo-img"
                        className="img-center"
                        src={`${process.env.PUBLIC_URL}/assets/images/header-logo.png`}
                        alt="MetaMind Logo"
                      />
                    </Link>
                  </div>

                  {/* burger – works via the original `main.js` */}
                  <div className="d-flex flex-row">
                    <div className="btn-show-menu-mobile menabar menubar--squeeze">
                      <span className="menubar-box"><span className="menubar-inner" /></span>
                    </div>

                    {/* desktop menu */}
                    <nav className="main-menu menu-mobile" id="menu">
                      <ul className="menu">
                        <li className="mega-menu-item"><Link to="/">Home</Link></li>
                        <li className="mega-menu-item"><Link to="/about-us">About Us</Link></li>
                        <li className="mega-menu-item"><Link to="/services">Our Services</Link></li>
                        <li className="mega-menu-item"><Link to="/language">Language</Link></li>
                        <li className="mega-menu-item"><Link to="/industry">Industry</Link></li>
                      </ul>
                    </nav>

                    {/* “Get A Quotes” button */}
                    <div className="header_extra d-flex flex-row align-items-center ml-auto">
                      <div className="header_btn">
                        <Link
                          className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-dark"
                          to="/contact-us"
                        >
                          Get A Quotes
                        </Link>
                      </div>
                    </div>
                  </div>{/* flex */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
